var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('img',{class:_vm.position === 'left' ? 'homeIcon' : 'homeIconRight',attrs:{"src":"https://cdn-xcx-qunsou.weiyoubot.cn/material/20220511/143372aed4285cba97f6154c4e708f74.svg","alt":""},on:{"click":_vm.toHome}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-52f03e2a","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/homeIcon.vue
// module id = null
// module chunks = 